import Partner from '../Partner/Partner';

export default interface Coupon {
    partner: Partner;
    isActive: boolean;
    partnerId: any;
    usageLimit: number;
    expiryDate: any;
    value: number;
    discountType: DiscountType;
    couponType: CouponType;
    name: string;
    code: string;
    createdOn: any;
    id: number;
    numberOfUsages: number
}

export enum DiscountType {
    Absolute, Percentage
}

export enum CouponStatus {
    Active, Inactive
}

export enum CouponType {
    Individual, Partner
}